import Vue from 'vue';
import App from './App.vue';
import VueGtm from 'vue-gtm';
import router from './router';
import vuetify from './plugins/vuetify';
import vueHeadful from 'vue-headful';
import VueDragscroll from 'vue-dragscroll';
import Vuex from 'vuex';
import store from './store';
import 'es6-promise/auto';

Vue.config.productionTip = false;
Vue.config.performance = true;

Vue.prototype.$VUE_APP_AIRTABLE_URL = "https://api.airtable.com/v0/";
Vue.prototype.$VUE_APP_AIRTABLE_API_KEY = "patF5rOpaYec6tD62.631582bd66a824cb960bb7c14bae85853ff3d14c4a41c9eb8cc2da81754f49a8";
Vue.prototype.$VUE_APP_AIRTABLE_BASE = "appj5dUHuKMVFqVT8";
Vue.prototype.$VUE_APP_AIRTABLE_CONTACT_BASE = "appVZpBZMEB67XrPr";

// GTM
Vue.use(VueGtm, {
    id: 'GTM-58BHWT7', // Your GTM single container ID or array of container ids ['GTM-xxxxxxx', 'GTM-yyyyyyy']
    // queryParams: { // Add url query string when load gtm.js with GTM ID (optional)
    //   gtm_auth:'AB7cDEf3GHIjkl-MnOP8qr',
    //   gtm_preview:'env-4',
    //   gtm_cookies_win:'x'
    // },
    enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
    debug: false, // Whether or not display console logs debugs (optional)
    loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
    vueRouter: router, // Pass the router instance to automatically sync with router (optional)
    // ignoredViews: ['homepage'] // If router, you can exclude some routes name (case insensitive) (optional)
});

// Drag Scrolling
Vue.use(VueDragscroll);


// State management
Vue.use(Vuex);

// Title Component
Vue.component('vue-headful', vueHeadful);

new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
}).$mount('#app');